import { render, staticRenderFns } from "./ProductACVNumbers.vue?vue&type=template&id=0dd47ef9&scoped=true&"
import script from "./ProductACVNumbers.vue?vue&type=script&lang=js&"
export * from "./ProductACVNumbers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd47ef9",
  null
  
)

export default component.exports